import { atom as t } from "jotai";
import { atomWithDefault as a } from "jotai/utils";
const m = t({
  show: !1,
  message: null
}), l = a((o) => o(m)), f = t(
  null,
  (o, e, s) => {
    e(l, (n) => ({ ...n, ...s }));
  }
), u = t(null), i = t(!1);
export {
  l as bannerAtom,
  m as bannerAtomDefault,
  i as isDatePickerPageAtom,
  u as searchResultsAtom,
  f as setBannerAtom
};
